module.exports = __webpack_public_path__ + "static/media/2.16_preview.8bf52cd7.png";